var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C4.5101e-07 7.16344 7.16344 4.5098e-07 16 0Z",
    fill: "#FDECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2613 12.8104C15.2769 12.608 15.4456 12.4518 15.6486 12.4518C15.8481 12.4518 16.0151 12.603 16.035 12.8015L16.2265 14.717C16.3075 15.5266 16.7751 16.247 17.4815 16.6507L18.6548 17.3212C18.7721 17.3882 18.8445 17.5129 18.8445 17.648C18.8445 17.8961 18.6085 18.0763 18.3691 18.011L16.4468 17.4868C15.5684 17.2472 14.9838 16.4177 15.0537 15.5099L15.2613 12.8104Z",
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    d: "M11.5471 8.55225C11.6427 8.15302 12.1522 8.03265 12.4163 8.34717C12.809 8.81531 13.4588 8.95841 14.0486 8.79885C14.6707 8.63055 15.325 8.54053 16.0002 8.54053L16.384 8.55029C20.3292 8.75012 23.4669 12.0125 23.467 16.0073C23.467 20.131 20.1239 23.474 16.0002 23.4741C11.8765 23.4741 8.53345 20.1311 8.53345 16.0073C8.53346 15.5543 8.57371 15.1106 8.65095 14.6797C8.72027 14.2931 9.11638 14.0727 9.49464 14.1786C9.87308 14.2847 10.0894 14.6773 10.0285 15.0656C9.98006 15.3746 9.95534 15.6891 9.95532 16.0073C9.95532 19.3456 12.662 22.0522 16.0002 22.0522C19.3384 22.0522 22.0442 19.3455 22.0442 16.0073C22.044 12.7734 19.5046 10.1329 16.3108 9.97119L16.0002 9.96338C15.676 9.96338 15.3558 9.98863 15.0418 10.0383C14.5518 10.1158 14.3864 10.6947 14.7053 11.0747C14.9697 11.39 14.7607 11.8717 14.3499 11.895L11.3704 12.064C11.0362 12.0827 10.7781 11.7743 10.8557 11.4487L11.5471 8.55225Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/eventIcon.a9fb014bfff89664c5f289d8a63bf083.svg";
export { ForwardRef as ReactComponent };